'use strict';
module.exports = function nodeCenterPoint(node) {
	return {x: node.left + (node.width / 2), y: node.top + (node.height / 2)};
};
